const HEADERS = [
  '日付',
  '経由売上',
  'サイト月商',
  '配信カバー率',
];

const FIELDS = [
  'start_at',
  'all_campaign.conversion_price',
  'all_access.conversion_price',
  'conversion_cover_rate',
];

const FORMAT = 'YYYYMM';

angular.module('zc')
  .component('zcSiteReportConversionCover', {
    templateUrl: '/templates/projects.site_reports/conversion_cover.html',
    bindings: { project: '<' },
    controller: zcSiteReportConversionCover,
  });

zcSiteReportConversionCover.$inject = ['$scope', '$window', 'Apollo', 'ChartV2', 'lineChartV2Config'];
function zcSiteReportConversionCover($scope, $window, Apollo, ChartV2, currencies, lineChartV2Config) {
  const vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / 10 ** $scope.currency.fractionSize;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.dailyStats) return;
    vm.filename = getFilename();
    vm.getCSV = getCSV;
    setChartConfig();
  });

  function getFilename() {
    const yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return `conversion-cover-${vm.project.apikey}-${yearMonth}.csv`;
  }

  function getCSV() {
    if(!vm.project.dailyStats) return;
    const result = [];
    result.push(HEADERS);
    vm.project.dailyStats.forEach(stat => {
      const row = FIELDS.map(field => _.get(stat, field));
      result.push(row);
    });
    return result;
  }

  function setChartConfig() {
    const allAccesses = [];
    const allCampaigns = [];
    vm.project.dailyStats.forEach(stat => {
      if(!stat.conversion_cover_rate) return;
      const startAt = moment(stat.start_at).valueOf();
      allAccesses.push([startAt, stat.all_access.conversion_price]);
      allCampaigns.push([startAt, stat.conversion_cover_rate * 100]);
    });
    const chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: { formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 0)} 円` } },
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: { formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 2)} %` } },
      }]
    });
    vm.chartConfig = chart.getConfig();
    chart.addSeries({
      type: 'column',
      name: '経由売上',
      data: allAccesses,
      tooltip: {
        valueSuffix: '円',
        valueDecimals: 0
      },
      yAxis: 0
    });
    chart.addSeries({
      type: 'line',
      name: '売上カバー率',
      data: allCampaigns,
      tooltip: {
        valueSuffix: '%',
        valueDecimals: 1
      },
      yAxis: 1
    });
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.site_reports/conversion_cover.controller.js